
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/purchaseOrder",
      function () {
        return require("private-next-pages/purchaseOrder/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/purchaseOrder"])
      });
    }
  